import { Box, Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { IconButtonWithOptions, Typography } from 'ComponentLibrary/src/piazza'
import { Link } from 'ComponentLibrary/src/piazza/text/Link/Link'
import { PaperclipIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'
import { translateMimeType } from 'ComponentLibrary/src/common/files'
import { Document } from 'ComponentLibrary/src/molecules/FileUploadModal/types'
import { ContentChip } from 'ComponentLibrary/src/piazza/content'

type TaskAttachmentItemProps = {
    displayedItem: Document
    onClick: () => void
    onEdit?: () => void
    onDelete: () => void
    copy?: Partial<TaskAttachmentItemCopy>
}

export type TaskAttachmentItemCopy = {
    edit: string
    delete: string
    optionsAriaLabel: string
}

const DEFAULT_TASK_ATTACHMENT_ITEM_COPY: TaskAttachmentItemCopy = {
    edit: 'Bearbeiten',
    delete: 'Löschen',
    optionsAriaLabel: 'Aufgaben Anhänge Optionen',
}

export function TaskAttachmentItem({ displayedItem, onClick, onEdit, onDelete, copy }: TaskAttachmentItemProps) {
    const resolvedCopy = { ...DEFAULT_TASK_ATTACHMENT_ITEM_COPY, ...copy }
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="column" padding={`${tokens.SizingSpacing200} 0`} gap={tokens.SizingSpacing050}>
                <Box onClick={onClick} sx={{ maxWidth: '378px' }}>
                    <Link href="#" ellipsis label={displayedItem.name} />
                </Box>
                <Stack
                    direction="row"
                    columnGap={tokens.SizingSpacing150}
                    rowGap={tokens.SizingSpacing075}
                    alignItems="center"
                    flexWrap="wrap"
                    minHeight="22px"
                >
                    <Stack direction="row" gap={tokens.SizingSpacing050}>
                        <PaperclipIcon size={tokens.SizingIconS} color={tokens.ColorIconDefault} weight="bold" />
                        <Typography variant="textS" color={tokens.ColorTextDefault}>
                            {translateMimeType(displayedItem.content_type)}
                        </Typography>
                    </Stack>
                    {displayedItem.tags?.map((tag) => (
                        <ContentChip key={tag.title} size="small" label={tag.title} color={tag.color} />
                    ))}
                </Stack>
            </Stack>
            <IconButtonWithOptions
                variant="tertiary"
                size="medium"
                options={[
                    ...(onEdit
                        ? [
                              {
                                  title: resolvedCopy.edit,
                                  icon: <PencilSimpleIcon color={tokens.ColorIconBoldest} weight="bold" />,
                                  callback: onEdit,
                              },
                          ]
                        : []),
                    {
                        title: resolvedCopy.delete,
                        danger: true,
                        icon: <TrashIcon weight="bold" />,
                        callback: onDelete,
                    },
                ]}
                ariaLabel={resolvedCopy.optionsAriaLabel}
            />
        </Stack>
    )
}
